import React from 'react';
import PageHeader from '../components/PageHeader';
import SessionRequestForm from '../components/SessionRequestForm';
import { MapPin, Mail, Clock } from 'lucide-react';
import usePageMeta from '../hooks/usePageMeta';

const Contact = () => {
  usePageMeta({
    title: 'Contact — Book a Seattle Spanking Session',
    description: 'Contact RealOTK to book a confidential spanking session in Seattle, Tacoma, Everett, Bellevue, or greater Western Washington. OTK, paddling, whipping, and cane discipline. All inquiries answered privately within 24-48 hours. First session free.',
    path: '/contact',
  });
  return (
  <div>
    <PageHeader
      eyebrow="Get in touch"
      title="Contact"
      subtitle="All inquiries are confidential. I respond personally within 24-48 hours."
      image="https://images.unsplash.com/photo-1519337265831-281ec6cc8514?auto=format&fit=crop&w=3840"
    />
    <section className="bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-20 md:py-28 grid lg:grid-cols-5 gap-12">
        <div className="lg:col-span-2 space-y-10">
          <div>
            <p className="text-neutral-500 text-xs uppercase tracking-[0.3em] mb-3">Service Area</p>
            <h3 className="font-serif text-3xl text-neutral-900 mb-2">Seattle Region</h3>
            <p className="text-neutral-600 leading-relaxed">
              Serving Seattle, Tacoma, Everett and Bellevue and the surrounding areas of Washington.
            </p>
          </div>
          <div className="space-y-5">
            <div className="flex items-start gap-4">
              <MapPin size={22} className="text-neutral-900 mt-1" strokeWidth={1.5} />
              <div>
                <p className="font-medium text-neutral-900">Location</p>
                <p className="text-neutral-600 text-sm">Western Washington — exact address shared upon booking</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <Mail size={22} className="text-neutral-900 mt-1" strokeWidth={1.5} />
              <div>
                <p className="font-medium text-neutral-900">Email</p>
                <p className="text-neutral-600 text-sm">realotk@mail.com</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <Clock size={22} className="text-neutral-900 mt-1" strokeWidth={1.5} />
              <div>
                <p className="font-medium text-neutral-900">Response Time</p>
                <p className="text-neutral-600 text-sm">Within 24-48 hours, always privately.</p>
              </div>
            </div>
          </div>
          <div className="bg-neutral-50 border border-neutral-200 p-6">
            <p className="text-sm text-neutral-700 leading-relaxed">
              <span className="font-semibold text-neutral-900">First sessions are always free.</span>{' '}
              This gives you the ability to determine if we are a good fit before you invest
              anything monetarily.
            </p>
          </div>
        </div>
        <div className="lg:col-span-3">
          <SessionRequestForm />
        </div>
      </div>
    </section>
  </div>
  );
};

export default Contact;
